export const requiredValidator = (value: string | undefined) => (value ? "" : "This field is required.");

export const emailValidator = (value: string | undefined) => {
    if (!value) {
        return "This field is required.";
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value) ? "" : "Please enter a valid email address.";
};

export const passwordValidator = (value: string | undefined) => {
    const requiredValidation = requiredValidator(value);
    if (requiredValidation) {
        return requiredValidation;
    }

    return value && value.length >= 8 ? "" : "Password must be at least 8 characters long.";
};
